
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/FAQs",
      function () {
        return require("private-next-pages/FAQs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/FAQs"])
      });
    }
  